import * as Sentry from '@sentry/react'

const isDev = import.meta.env.DEV

export const logger = {
  error(message: string, error?: unknown, context?: Record<string, unknown>) {
    if (isDev) {
      console.error(message, error, context)
    }
    if (error instanceof Error) {
      Sentry.captureException(error, { extra: { message, ...context } })
    } else {
      Sentry.captureMessage(message, { level: 'error', extra: { error, ...context } })
    }
  },
  warn(message: string, context?: Record<string, unknown>) {
    if (isDev) {
      console.warn(message, context)
    }
    Sentry.captureMessage(message, { level: 'warning', extra: context })
  },
}
